import { cva } from 'class-variance-authority';

export const TEXTAREA_VARIANTS = cva(
  'w-full min-w-0 h-[120px] rounded-xs border outline-none text-neutral-9 bg-neutral-0 placeholder:text-neutral-6 transition-colors disabled:cursor-not-allowed font-medium dark:bg-neutral-10 dark:border-neutral-9 dark:text-neutral-0 dark:placeholder:text-neutral-7',
  {
    variants: {
      size: {
        sm: 'px-3 py-2 text-xs',
        default: 'px-4 py-3 text-sm',
        lg: 'px-4 py-3 text-base',
      },
      variant: {
        default:
          'border-neutral-4 hover:border-neutral-6 focus-visible:border-primary-base dark:border-neutral-9 dark:hover:border-neutral-8 dark:focus-visible:border-primary-base',
        error:
          'border-semantic-error-base hover:border-semantic-error-base focus-visible:border-semantic-error-base',
      },
      disabled: {
        true: 'pointer-events-none border-neutral-4 !text-neutral-6 bg-neutral-2 dark:border-neutral-8 dark:text-neutral-7 dark:bg-neutral-9',
      },
    },
    defaultVariants: {
      size: 'default',
      variant: 'default',
      disabled: false,
    },
  },
);

export const TEXTAREA_LABEL_VARIANTS = cva('font-semibold', {
  variants: {
    size: {
      sm: '!text-body-xs',
      default: '!text-body-sm',
      lg: '!text-body-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
